import { makeStyles } from '@mui/styles';

const styles = makeStyles(({ breakpoints }) => {
  return {
    featuresSubtitle: {
      marginRight: '10px',
      [breakpoints.down(500)]: {
        fontSize: '30px',
      }
    },
    featuresContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '50px',
      [breakpoints.down(500)]: {
        marginBottom: '10px'
      }
    },
    featuresWrapper: {
      position: 'relative',
      padding: '40px 0 0 0',
      marginBottom: '40px',
      maxWidth: '1465px',
      margin: '0 auto',
      textAlign: 'center',
      [breakpoints.down(500)]: {
        padding: '10px 0',
      }
    },
    featuresMobileWrapper: {
      display: 'flex',
      alignItems: 'center',
      overflowX: 'scroll',
      scrollBehavior: 'smooth',
      scrollSnapType: 'x mandatory'
    },
    featuresMobileCardWrapper: {
      width: '85vw',
      scrollSnapAlign: 'start'
    },
    actionIcon: {
      padding: 0,
      margin: 0
    },
    mobileActionIcon: {
      background: 'rgba(0,0,0,0.2)',
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      position: 'absolute',
      bottom: '25px',
      zIndex: 10,
    }
  };
});

export default styles;
